"use client";
import React, { useState, useEffect } from "react";

import { CardContent } from "./ui/card";
import { Button } from "./ui/button";
import { Loader2 } from "lucide-react";
import coin from "../assets/images/placeholder/crypto-colour.png";
import { getTradeRate } from "../services/digitalWalletService";
import { useAuth } from "../context/AuthContext";
import { useNotification } from "../context/NotificationProvider";
import { Skeleton } from "./ui/skeleton";
import InvestGraph from "./InvestGraph";
import CurrencyFormatter from "../utils/currencyFormatter";
import { useInvestGraph } from "../hooks/query/queries";
export default function InvestStepTwo({
  onSelect,
  onConfirm,
  selectedAsset,
  setSelectedAsset,
  setParentAmount,
  parentAmount,
  address,
  setAddress,
  parentCurrentAmount,
  setParentCurrentAmount,
  onNext,
  maxAmount,
  minAmount,
  durationYearly,
  amountYearly,
  isLoading,
  assetsOwned,
  assetId,
  productId,
}) {
  const [, setConvertedValue] = useState("0.000");
  const [, setAvailableAmount] = useState(null);
  const [isBaseInput] = useState(true);
  const [rate, setRate] = useState(null);
  const [selectedBalance] = useState(selectedAsset);
  const [, setLoading] = useState(true);
  const [, setError] = useState(null);
  const [showGraph, setShowGraph] = useState(false);
  const [currentAmount, setCurrentAmount] = useState(parentCurrentAmount);
  const [holdStep, setHoldStep] = useState(true);
  const [exceedFlag] = useState(false);
  const [loadingAsset, setLoadingAsset] = useState(true);
  const [noAmountFlag] = useState(false);
  const [minAmountFlag] = useState(false);
  const [maxAmountFlag] = useState(false);
  const { settings } = useAuth();
  const { showPersistentMessage } = useNotification();
  const defaultCurrency = settings?.preferences?.localCurrency || "ZAR";
  const pair =
    selectedBalance?.asset + "-" + defaultCurrency.toString().toLowerCase();
  const performanceTimeframe =
    settings?.preferences?.performancePeriod || "monthly";
  const { data: graphObject, isLoading: loadingGraph } = useInvestGraph(
    productId,
    currentAmount,
    performanceTimeframe
  );

  useEffect(() => {
    if (!selectedBalance || pair === "zar-zar") return;

    const fetchRate = async () => {
      try {
        const data = await getTradeRate(selectedBalance?.assetId, "sell", pair);

        setRate(data.data.data);
      } catch (err) {
        showPersistentMessage(
          "error",
          "Trading rates are not available at the moment please try again later"
        );
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchRate();
  }, [selectedBalance, pair, showPersistentMessage]);

  // useEffect(() => {
  //   const selectAsset = () => {
  //     const assetSelected = assetsOwned?.find(
  //       (asset) => asset.assetId === assetId
  //     );

  //     setSelectedAsset(assetSelected);
  //   };
  //   selectAsset();
  // }, [assetsOwned]);

  useEffect(() => {
    if (selectedBalance) {
      setAvailableAmount(selectedBalance.availableAmount);
    }
  }, [selectedBalance]);

  // const payQuoteData = {
  //   amount: currentAmount,
  //   assetId: selectedBalance?.assetId,
  // };

  useEffect(() => {
    const number = parseFloat(currentAmount || 0);

    if (isNaN(number) || number === 0) {
      setConvertedValue(0);
      return;
    }

    if (!rate) {
      setConvertedValue(number);
      return;
    }

    if (isBaseInput) {
      const convertedValue = number * rate.rate;
      setConvertedValue(convertedValue);
      // takeInOutAmount(number);
    } else {
      const convertedValue = number / rate.rate;
      setConvertedValue(convertedValue);
      // takeOutInAmount(convertedValue);
    }
  }, [currentAmount, isBaseInput, rate]);

  useEffect(() => {
    if (!selectedAsset) return;
    if (selectedAsset) {
      setLoadingAsset(false);
    }
  }, [selectedAsset]);
  const maxPayAmount = () => {
    const maxAmount = selectedBalance?.availableAmount;
    setCurrentAmount(maxAmount);
    setParentCurrentAmount(maxAmount);
    handleAmountChange({ target: { value: maxAmount } });
  };

  const handleAmountChange = (e) => {
    const value = e.target.value;
    setCurrentAmount(value);
    setParentCurrentAmount(value);
    const input = parseFloat(value);
    const available = parseFloat(selectedAsset?.availableAmount);
    // if (available == 0) {
    //   setHoldStep(true);
    //   setNoAmountFlag(true);
    // }
    if (input > 0) {
      setHoldStep(false);
    }
    if (!input || input <= 0) {
      setHoldStep(true);
    }
    if (available > 0) {
      if (input > 0) {
        setHoldStep(false);
      }
      if (!input || input <= 0) {
        setHoldStep(true);
      }

      // if (input >= minAmount) {
      //   setMinAmountFlag(false);
      // }
      // if (input < minAmount) {
      //   setMinAmountFlag(true);
      // }
      // if (input <= maxAmount) {
      //   setMaxAmountFlag(false);
      // }
      // if (input > maxAmount) {
      //   console.log("maxAmount", maxAmount);
      //   setMaxAmountFlag(true);
      // }
    }
  };
  const activeError = (() => {
    if (exceedFlag) return "exceed";
    if (noAmountFlag) return "noAmount";
    if (minAmountFlag) return "minAmount";
    if (maxAmountFlag) return "maxAmount";
    return null;
  })();
  const handleNext = () => {
    if (!loadingGraph) {
      setShowGraph(true);
    }
  };
  const handleNextFromGraph = () => {
    onNext?.();
  };
  const formatter = new CurrencyFormatter();
  return (
    <CardContent>
      {!showGraph && (
        <>
          <div className="grid grid-cols-6 gap-4 mb-6 w-full">
            {/* Button: spans 1 column */}
            <div className="col-span-2">
              <label className="text-gray-600 text-sm">Currency</label>
              {loadingAsset ? (
                <div className="w-full flex items-center justify-between py-4  px-4 rounded-2xl border border-gray-300 bg-muted/50">
                  <div className="flex items-center gap-3 ">
                    <Skeleton className="w-10 h-10 rounded-full bg-gray-300" />

                    <div className="flex flex-col gap-1">
                      <Skeleton className="w-10 h-5 rounded-full bg-gray-300" />
                    </div>
                  </div>
                  <Skeleton className="w-6 h-6 rounded-full bg-gray-300" />
                </div>
              ) : (
                <Button
                  variant="outline"
                  className="w-full flex items-center justify-between py-8 rounded-2xl hover:border-brand-primary transition-colors"
                >
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full flex items-center justify-center">
                      {selectedAsset ? (
                        <img
                          src={selectedAsset?.assetIcon || selectedAsset?.image}
                          alt={selectedAsset?.assetName}
                          width={32}
                          height={32}
                          className="text-white"
                        />
                      ) : (
                        <img
                          src={coin}
                          alt="Default Asset"
                          width={32}
                          height={32}
                          className="text-white"
                        />
                      )}
                    </div>
                    <div className="text-left">
                      <div className="font-semibold">
                        {selectedAsset?.asset.toUpperCase()}
                      </div>
                    </div>
                  </div>
                </Button>
              )}
            </div>

            <div className="col-span-4 space-y-2 flex flex-col">
              <label className="text-gray-600 text-sm">Available balance</label>
              <div className="p-4 rounded-2xl bg-gray-50 flex-1 flex items-center">
                <div className="text-xl font-semibold text-gray-600">
                  {selectedAsset?.availableAmountFormatted ||
                    selectedAsset?.forattedAvailableAmount}
                </div>
              </div>
            </div>
          </div>

          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-800 mb-2">
              Enter amount
            </label>
            <div
              className={`relative flex items-center border rounded-lg px-4 py-2 bg-transparent  ${
                exceedFlag || noAmountFlag || minAmountFlag || maxAmountFlag
                  ? "border-2 border-rose-500 "
                  : " "
              }`}
            >
              <input
                type="text"
                placeholder={`0 ` + selectedAsset?.asset?.toUpperCase()}
                value={currentAmount}
                onChange={handleAmountChange}
                className={`flex-1 py-5 outline-none bg-transparent text-base font-semibold bg-transparent outline-none 
                             focus-visible:ring-0 focus-visible:outline-none transition-colors duration-200 ease-in-out text-[24px] text-text-secondary
                             ${
                               exceedFlag ||
                               noAmountFlag ||
                               minAmountFlag ||
                               maxAmountFlag
                                 ? "text-rose-500"
                                 : "text-brand-primary"
                             }`}
              />
              <Button
                onClick={maxPayAmount}
                variant="outline"
                className="rounded-full"
              >
                Max
              </Button>
            </div>
            {activeError === "exceed" && (
              <p className="mt-1 text-sm text-rose-500">
                Cannot invest more than available amount{" "}
                {formatter.format(
                  selectedAsset?.availableAmount,
                  selectedAsset?.asset?.toUpperCase()
                )}
              </p>
            )}
            {activeError === "noAmount" && (
              <p className="mt-1 text-sm text-rose-500">
                You do not have an available amount to apply with
              </p>
            )}
            {activeError === "minAmount" && (
              <p className="mt-1 text-sm text-rose-500">
                Amount less than minimum allowed {minAmount}
              </p>
            )}
            {activeError === "maxAmount" && (
              <p className="mt-1 text-sm text-rose-500">
                Amount exceeds the maximum allowed deposit: {maxAmount}
              </p>
            )}
          </div>
          <Button
            type="primary"
            disabled={holdStep || loadingGraph}
            onClick={handleNext}
            className="px-32 py-3 mt-5 bg-gradient-to-r flex justify-self-center from-purple-500 to-rose-600 text-white py-3 rounded-full text-sm font-medium"
          >
            {loadingGraph && <Loader2 className="animate-spin w-4 h-4" />}
            Next
          </Button>
        </>
      )}
      {showGraph && (
        <InvestGraph
          onNext={handleNextFromGraph}
          amount={currentAmount}
          durationYearly={durationYearly}
          graphObject={graphObject}
          amountYearly={amountYearly}
        />
      )}
    </CardContent>
  );
}
